import { render, staticRenderFns } from "./Etapa01.vue?vue&type=template&id=f0501de0"
import script from "./Etapa01.vue?vue&type=script&lang=js"
export * from "./Etapa01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports